import { render, staticRenderFns } from "./MinutesSinceCell.vue?vue&type=template&id=4531fe32&scoped=true&"
import script from "./MinutesSinceCell.vue?vue&type=script&lang=babel&"
export * from "./MinutesSinceCell.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4531fe32",
  null
  
)

export default component.exports